<template>
  <div id="SleepChartReportPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="نمودار خواب"></ActionBar>
    <div class=" container mx-auto no-gutters p-0 mt-10">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4">
          <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب سال:</span></div>
          <v-select
              v-model.number="selectedYear"
              :items="years"
              class="input-border"
              dense
              hide-details
              placeholder="انتخاب سال"
              solo
              @change="setYear">
          </v-select>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب ماه:</span></div>
          <v-select
              ref='monthPicker'
              v-model.number="selectedMonth"
              :disabled="!showMonthPicker"
              :items="months"
              :menu-props="{value:openMonthPicker}"
              class="input-border"
              dense
              hide-details
              item-text="text"
              item-value="id"
              placeholder="انتخاب ماه"
              solo
              @change="setDate"
              @click="openMonthPicker  = true">
          </v-select>
        </div>
        <div class="col-6 col-sm-4 col-md-2 text-left align-self-end">
          <v-btn :disabled="selectedYear === null || selectedMonth===null" block class="px-8" color="primary" rounded
                 @click="search">
            جستجو
          </v-btn>
        </div>
      </div>
      <div class="row  mx-auto no-gutters p-0 mt-10">
        <div v-if="dataLoading" class="col-12 mt-10 col-md-6 col-lg-3 mx-auto text-center">
          در حال جستجو
          <v-progress-linear
              color="deep-purple accent-4"
              height="6"
              indeterminate
              rounded
          ></v-progress-linear>
        </div>
        <div v-else-if="isLoaded" class="col-12 col-sm-10  mx-auto ">
          <div v-if="!hasReport" class="mx-2 mt-5">
            <div class="col-12">
              <v-alert
                  border="bottom"
                  class="text-center"
                  color="forth"
                  dark>
                گزارشی برای تاریخ انتخاب شده وجود ندارد.
              </v-alert>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-12 col-md-6 ">
              <SleepChart v-if="isChartLoaded"
                          :canvasID="'sleepQuantity'"
                          :chart-label="chartLabel"

                          :chart-title="'نمودار کمیت خواب'"
                          :first-red-slot="firstRedSlot"
                          :first-yellow-slot="firstYellowSlot"
                          :green-slot="greenSlot"
                          :second-red-slot="secondRedSlot"
                          :second-yellow-slot="secondYellowSlot"
                          :student-sleep-data="studentSleepData"/>
            </div>
            <div class="col-12 col-md-6 ">
              <SleepChart v-if="isChartSleepQualityLoaded"
                          :canvasID="'sleepQuality'"
                          :chart-label="chartQualityLabel"
                          :chart-min="0"
                          :chart-title="'نمودار کیفیت خواب'"
                          :first-red-slot="firstRedQualitySlot"
                          :first-yellow-slot="firstYellowQualitySlot"
                          :green-slot="greenQualitySlot"
                          :second-red-slot="secondRedQualitySlot"
                          :second-yellow-slot="secondYellowQualitySlot"
                          :student-sleep-data="studentSleepQualityData"/>
            </div>
          </div>
        </div>
      </div>

    </div>
    <FooterMenu/>
  </div>

</template>

<script>
import SleepChart from "../../components/SleepChart";
import FooterMenu from "../../components/FooterMenu";
import ActionBar from "../../components/ActionBar";


export default {
  name: "SleepChartReport",
  metaInfo: {
    title: 'مسیربرتر-نمودار خواب'
  },
  components: {ActionBar, FooterMenu, SleepChart},
  data: () => ({
    months: [
      {id: 1, text: 'فروردین'},
      {id: 2, text: 'اردیبهشت'},
      {id: 3, text: 'خرداد'},
      {id: 4, text: 'تیر'},
      {id: 5, text: 'مرداد'},
      {id: 6, text: 'شهریور'},
      {id: 7, text: 'مهر '},
      {id: 8, text: 'آبان '},
      {id: 9, text: 'آذر '},
      {id: 10, text: 'دی'},
      {id: 11, text: 'بهمن'},
      {id: 12, text: 'اسفند '},
    ],
    dataLoading: false,
    isLoaded: false,
    hasReport: false,
    openMonthPicker: false,
    showMonthPicker: false,
    years: [],
    selectedYear: null,
    startDate: null,
    endDate: null,
    selectedMonth: null,
    firstRedQualitySlot: [],
    studentSleepQualityData: [],
    secondRedQualitySlot: [],
    greenQualitySlot: [],
    firstYellowQualitySlot: [],
    secondYellowQualitySlot: [],
    chartLabel: [],
    chartQualityLabel: [],
    studentSleepData: [],
    firstRedSlot: [],
    firstYellowSlot: [],
    greenSlot: [],
    secondYellowSlot: [],
    secondRedSlot: [],
    isChartLoaded: false,
    isChartSleepQualityLoaded: false,
    items: [
      {ModifiedDate: '1400/01/01', Minutes: 5, StartTime: 24, EndTime: '8'},
      {ModifiedDate: '1400/01/02', Minutes: 6, StartTime: 23, EndTime: '9'},
      {ModifiedDate: '1400/01/03', Minutes: 8, StartTime: 24, EndTime: '7:30'},
      {ModifiedDate: '1400/01/04', Minutes: 10, StartTime: 22, EndTime: '4'},
    ]

  }),
  mounted() {
    let year = this.$convertDate((new Date()).toISOString()).slice(0, 4)
    this.years.push(year - 1, parseInt(year))



  },
  methods: {
    timeStringToSec(timeStr) {
      let parts = timeStr.split(":");
      return (parts[0] * 3600) +
          (parts[1] * 60) +
          (+parts[2]);
    },

    pad(num) {
      if (num < 10) {
        return "0" + num;
      } else {
        return "" + num;
      }
    },

    formatTime(seconds) {
      return (parseInt(this.pad(Math.floor(seconds / 3600))) + (parseInt(this.pad(Math.floor(seconds / 60) % 60) * 10 / 6) / 100)
      )
    },
    setYear() {
      this.showMonthPicker = true
      // this.openMonthPicker = true
    },
    setDate() {
      this.openMonthPicker = null

      this.startDate = this.$chooseMonth(this.selectedMonth, this.selectedYear).startDate
      this.endDate = this.$chooseMonth(this.selectedMonth, this.selectedYear).endDate

    },
    search() {
      this.dataLoading = true;
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartDate", this.startDate);
      urlencoded.append("EndDate", this.endDate);
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/_SleepQuality", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.isLoaded = true
            if (json.length > 0) {
              this.hasReport = true
              let items = json.sort((a, b) => a.ModifiedDate.localeCompare(b.ModifiedDate))
              let firstYellow = []
              let firstRedSlot = []
              let greenSlot = []
              let secondYellowSlot = []
              let secondRedSlot = []
              let labels = []
              let userSleepMin = []

              for (let i = 0; i < items.length; i++) {
                firstRedSlot.push(4)
                firstYellow.push(8)
                greenSlot.push(10)
                secondYellowSlot.push(14)
                secondRedSlot.push(18)
                labels.push(this.$convertDate(items[i].ModifiedDate))
                userSleepMin.push(this.$roundNum(items[i].Minutes / 60))
              }
              this.chartLabel = labels;
              this.studentSleepData = userSleepMin;
              this.firstYellowSlot = firstYellow;
              this.firstRedSlot = firstRedSlot
              this.greenSlot = greenSlot
              this.secondYellowSlot = secondYellowSlot
              this.secondRedSlot = secondRedSlot

              this.isChartLoaded = true


              let secondYellowQualitySlot = []
              let greenQualitySlot = []
              let firstYellowQualitySlot = []
              let secondRedQualitySlot = []
              let studentSleepQualityData = []
              let labelQuality = []

              for (let i = 0; i < items.length; i++) {
                secondYellowQualitySlot.push(31)
                greenQualitySlot.push(29)
                firstYellowQualitySlot.push(25)
                secondRedQualitySlot.push(36)
                labelQuality.push(this.$convertDate(items[i].ModifiedDate))

                studentSleepQualityData.push(this.formatTime(this.timeStringToSec(items[i].EndTime) + this.timeStringToSec(items[i].StartTime)))
                this.firstRedQualitySlot.push(12)
              }

              this.studentSleepQualityData = studentSleepQualityData
              this.firstYellowQualitySlot = firstYellowQualitySlot
              this.secondYellowQualitySlot = secondYellowQualitySlot
              this.greenQualitySlot = greenQualitySlot
              this.secondRedQualitySlot = secondRedQualitySlot
              this.chartQualityLabel = labelQuality

              this.isChartSleepQualityLoaded = true

            } else {
              this.hasReport = false
            }

            this.dataLoading = false
          })
          .catch(error => console.log('error', error));
    },
  }
}
</script>

<style scoped>

</style>
